module.exports = __webpack_public_path__ + "media/images/mailer/thumb_84-7a56e51fd11d66f1e609cd917c11e3a1.jpg";